import React, { useState } from 'react'
import './tabs-content.scss'

import useMediaQuery from '../../../utils/useMediaQuery'
import Tab1 from './view/Tab1'
import Tab2 from './view/Tab2'
import Tab3 from './view/Tab3'
import Tab4 from './view/Tab4'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import getUserInfo from '../../../utils/getUserInfo'
import { jsonToHash } from '../../../utils/crypto'
import { $Redime, WORDS } from '../../../constants/keywords'
import { LOCALE } from '../../../constants/activity-constants'

const userInfo = getUserInfo()
const tagInfo = async evt => {
  if (evt) {
    let text = evt.target?.textContent
    if (text) {
      pushEventData({
        event: 'Interacciones_Home_RompeTabus',
        category: '¿Como participar?',
        label: text,
        user_data: userInfo && [
          await jsonToHash({
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          }),
        ],
        log_status: userInfo ? 'Yes' : 'Not',
      })
    }
  }
}

function getTabs(isMobile) {
  if (LOCALE === 'es-BO') {
    return {
      1: { label: 'Inicia sesión', content: <Tab1 isMobile={isMobile} /> },
      2: { label: 'Juega', content: <Tab3 isMobile={isMobile} /> },
      3: { label: 'Gana', content: <Tab4 isMobile={isMobile} /> },
    }
  }
  if (LOCALE === 'es-UY') {
    return {
      1: { label: 'Iniciá sesión', content: <Tab1 isMobile={isMobile} /> },
      2: { label: 'Jugá', content: <Tab3 isMobile={isMobile} /> },
    }
  }
  
  return {
    1: {
      label: WORDS.inicia_sesion,
      content: <Tab1 isMobile={isMobile} />,
    },
    2: { label: $Redime, content: <Tab2 isMobile={isMobile} /> },
    3: {
      label: WORDS.juega,
      content: <Tab3 isMobile={isMobile} />,
    },
    4: {
      label: WORDS.Gana,
      content: <Tab4 isMobile={isMobile} />,
    },
  }
}

const TabsContent = ({ className = '', classNameForHeader = '' }) => {
  const isMobile = useMediaQuery()
  const [activeTab, setActiveTab] = useState('1')
  const tabs = getTabs(isMobile)
  return (
    <div className={'tabs ' + className}>
      <div className={'tabs__header ' + classNameForHeader}>
        {Object.keys(tabs).map((key, idx) => {
          const label = tabs[key].label
          let numbertab = idx + 1
          return (
            <div className={'tab '} key={tabs.label}>
              <a
                onClick={evt => {
                  tagInfo(evt)
                  setActiveTab(key)
                }}
                htmlFor={'tab-' + numbertab}
                className={
                  'tab-label ' + (activeTab === key ? ' --active ' : '')
                }
              >
                {numbertab} <span>{label}</span>
              </a>
            </div>
          )
        })}
      </div>

      <div className="tab-content">{tabs[activeTab].content}</div>
    </div>
  )
}

export default TabsContent
